export default {
  slug: "teeth-whitening-in-guwahati",
  title: "Teeth Whitening in Guwahati",
  subtitle: "Teeth Whitening- A brighter smile in just one visit",

  heroImage:
    "/dental-services/teeth-whitening/teeth-whitening-in-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Teeth Whitening at Magnum Dental Clinic, Guwahati",
      content: `
Teeth whitening is a safe and effective cosmetic dental procedure designed to remove stains and discoloration, giving you a noticeably brighter smile.

At **Magnum Dental Clinic, Guwahati**, we offer professional teeth whitening treatments that deliver fast, visible, and long-lasting results— far superior to over-the-counter products.
      `,
    },
    {
      type: "image",
      images: [
        "/dental-services/teeth-whitening.webp",
        "/dental-services/teeth-whitening/teeth-discolor-in-guwahati.webp",
        "/dental-services/teeth-whitening/teeth-doctor-in-guwahati.webp"        
      ],
      caption: "Images are for illustrative purposes only",
    },
    {
      type: "text",
      heading: "Benefits of Professional Teeth Whitening",
      content: `
Teeth whitening helps to:

✔ Brighten your smile instantly  
✔ Remove stubborn stains and discoloration  
✔ Enhance confidence and appearance  
✔ Deliver safe and controlled results  
✔ Achieve even whitening without damaging enamel  
✔ Provide faster results compared to home kits  

A brighter smile can make you look younger, healthier, and more confident.
      `,
    },

    {
      type: "text",
      heading: "Who can undergo Teeth Whitening procedure?",
      content: `
Teeth whitening is ideal if you have:

✔ Yellow or stained teeth  
✔ Discoloration from food, drinks, or smoking  
✔ Teeth darkened due to aging  
✔ A special event coming up (wedding, interview, function)  
✔ Healthy teeth and gums with cosmetic concerns  

Our team at **Magnum Dental Clinic, Guwahati**, will assess your oral health before treatment to ensure safe and effective whitening.
      `,
    },

    {
      type: "text",
      heading: "Is Teeth Whitening Safe?",
      content: `
Yes. Professional teeth whitening performed by a dentist is completely safe.

At **Magnum Dental Clinic**, we use high-quality whitening systems that protect your gums and tooth enamel while delivering excellent results.

You may experience mild sensitivity, which is temporary and manageable.
      `,
    },

    {
      type: "text",
      heading: "Teeth Whitening Procedure",
      content: `
The procedure typically includes:

✔ Cleaning and preparation of teeth  
✔ Protection of gums and soft tissues  
✔ Application of professional whitening gel  
✔ Activation (if required) for enhanced results  

The entire process usually takes 45–60 minutes, and results are visible immediately.
      `,
    },

    {
      type: "text",
      heading: "How Long Do Teeth Whitening Results Last?",
      content: `
Results can last from 6 months to over a year, depending on your oral habits and maintenance.

Avoiding tobacco and stain-causing foods, along with good oral hygiene, helps maintain brightness longer.

We also provide guidance on post-whitening care for long-lasting results.
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Teeth Whitening in Guwahati?",
      content: `
✔ Experienced cosmetic dentists  
✔ Advanced whitening technology  
✔ Safe, controlled procedures  
✔ Visible results in a single visit  
✔ Affordable whitening solutions  
✔ Personalized smile care  
      `,
    },
  ],

  faqs: [
    {
      q: "Does teeth whitening hurt?",
      a: "No. The procedure is painless. Some patients may experience mild sensitivity, which is temporary and manageable.",
    },
    {
      q: "How white will my teeth get?",
      a: "Most patients see teeth become several shades whiter in a single visit.",
    },
    {
      q: "Can whitening damage my teeth?",
      a: "Professional whitening does not damage enamel when done under dental supervision.",
    },
    {
      q: "Can everyone get teeth whitening?",
      a: "Most adults can, but whitening may not be suitable for crowns, veneers, or severely sensitive teeth. A consultation is required.",
    },
  ],

  cta: {
    heading: "Book Teeth Whitening Treatment at MDC, Guwahati",
    description: `
Don’t let stained teeth hold you back. A brighter smile is just one visit away.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 for consultation and pricing details

✨ Bright smile. Bold confidence.
    `,
    buttonText: "Book Teeth Whitening Appointment",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
